import store from '_redux/store';
import T from './Translate';
import TRANSLATION_KEYS from './keys';

export const Translate = T;
export const TRANSLATIONS = TRANSLATION_KEYS;

export function translateKey(key) {
  const resourceString = key.toLowerCase();

  if (TRANSLATION_KEYS.find(x => x.toLowerCase() === resourceString) === undefined) {
    throw new Error(`Using resource string "${resourceString}" without adding it to /src/js/translations/keys.js`);
  }

  const keys = store.getState().app.translations.keys;
  return keys[resourceString];
}
